module.exports = {"id":"204289","name":"Saido Berahino","rating":"74","photo":"./data/images/photos/1/204289.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SaidoBerahino0.json
// module id = 3772
// module chunks = 0